module.exports = __webpack_public_path__ + "static/media/closeHole.7c2abd7f.mp3";